import {useEffect} from '@wordpress/element';
import {sprintf} from '@wordpress/i18n';
import {i18n} from '../../../utils';

export const useValidateCheckout = (
    {
        title,
        isExpress,
        paymentData,
        emitResponse,
        onCheckoutValidation
    }) => {

    useEffect(() => {
        if (!isExpress) {
            const unsubscribe = onCheckoutValidation(() => {
                // validate that the order has been created.
                if (!paymentData?.orderId && !paymentData?.paymentToken) {
                    return {
                        type: emitResponse.responseTypes.FAIL,
                        errorMessage: sprintf(i18n.order_button_click, title)
                    }
                }
                return true;
            });
            return unsubscribe;
        }
    }, [isExpress, paymentData]);
}